import { Metrics } from '@src/metrics/Metrics';

const LATENCY_TYPE = 'com.amazon.ihmbees.coral#LatencyMetric';

/**
 *  The LatencyMetric class is used to record a latency time metric.
 *  After creating  new object you should call the start function
 *  to start recording the time. Then you should call stop() to stop
 *  the time and record the metric.
 *
 *  Example ProgramName: 'IhmFlyingDutchman'
 *  Usage:
 *      var lMetric = new LatencyMetric(storeId, MetricName, ProgramName, Operation)
 *      lMetric.start();
 *      //do stuff
 *      lMetric.stop();
 */
export class LatencyMetric extends Metrics {
    private isStarted;
    private isComplete;

    constructor(storeId, name, program, operation) {
        super(LATENCY_TYPE, storeId, name, program, operation);
        this.isStarted = false;
        this.isComplete = false;
    }

    public getIsStarted() {
        return this.isStarted;
    }

    public start() {
        if (this.isStarted) {
            console.warn('Tried to start timer twice.');
            return;
        }
        if (this.isComplete) {
            console.warn('MetricStartAfterCompletion - Tried to start timer that has already been completed.');
            return;
        }
        this.setStartTime(new Date().getTime());
        this.isStarted = true;
    }

    public setValueAndBroadcast(latencyInMillis) {
        if (this.isComplete) {
            console.warn('Tried to broadcast a timer that has already been stopped.');
            return;
        }
        this.isStarted = false;
        this.isComplete = true;
        const currentTime = new Date().getTime();
        if (!this.startTime) {
            this.setStartTime(currentTime);
        }
        this.setStopTime(currentTime);
        this.setValue(latencyInMillis);
        try {
            this.broadcastMetric();
        } catch (error) {
            console.error(error);
        }
    }

    public stop() {
        if (this.isComplete) {
            console.warn('Tried to stop timer that has already been stopped.');
            return;
        }
        if (!this.isStarted) {
            console.warn('Tried to stop timer before it was started.');
            return;
        }
        try {
            this.setValueAndBroadcast(new Date().getTime() - this.startTime);
        } catch (error) {
            console.error(error);
        }
    }
}
